import decode from 'jwt-decode';

class StorageHandler {

  
  setID(id) {
    // Saves user id to localStorage
    localStorage.setItem('cryodex_id', id);
  }

  setImage(image) {
    // Saves user id to localStorage
    localStorage.setItem('cryodex_profile_image', image);
  }

  setTutorialComplete() {
    localStorage.setItem('cryodex_tutorial_complete', true);
  }


  setProperties(id, ImageSource) {
    // Saves user token to localStorage
    this.setID(id);
    this.setImage(ImageSource);
  }

  ///////////////////////////////////////set error and getters/////////////////////////////
  setError(message){
    localStorage.setItem('error_message', message);
  }
  getError(){
    return localStorage.getItem('error_message');
  }
  removeError(){
    localStorage.removeItem('error_message');
  }


  setEmailError(message){
    localStorage.setItem('error_message1', message);
  }
  getEmailError(){
    return localStorage.getItem('error_message1');
  }
  removeEmailError(){
    localStorage.removeItem('error_message1');
  }

  setPasswordReset(message){
    localStorage.setItem('error_message2', message);
  }

  getPasswordReset(){
    return localStorage.getItem('error_message2');
  }
  removePasswordReset(){
    localStorage.removeItem('error_message2');
  }
///////////////////////////////////infodex status////////////
  setInfoDeleted(message){
    localStorage.setItem('success_message2', message);
  }
  getInfoDeleted(){
    return localStorage.getItem('success_message2');
  }
  removeInfoDeleted(){
    localStorage.removeItem('success_message2');
  }
  //////////////////////////////////////////////////////////////////////////

  logoutUser() {
    localStorage.removeItem('cryodex_id');
    localStorage.removeItem('cryodex_profile_image');
	localStorage.removeItem('cities');
	localStorage.removeItem('countries');
	localStorage.removeItem('userInfo');
	localStorage.removeItem('cryodexLinks');
	//window.location.reload();
  }

  getID() {
    return localStorage.getItem('cryodex_id');
  }

  getImage() {
    return localStorage.getItem('cryodex_profile_image');
  }

  getTutorialComplete() {
    return localStorage.getItem('cryodex_tutorial_complete');
  }

  
}

export default StorageHandler;
